export enum RegisterErrors {
    REG_TOKEN_ACCOUNT_NOT_NEW = 'REG_TOKEN_ACCOUNT_NOT_NEW',
    NOT_BLANK = 'NOT_BLANK'
}
